if(typeof HorizontalTabsComponent !== 'function'){
  class HorizontalTabsComponent extends HTMLElement {
    constructor() {
      super();

      this.buttons = this.querySelectorAll('[data-action="tab-trigger"]') || [];
      if(this.buttons.length == 0) return;

      this.buttonActive = this.querySelector('button.active[data-action="tab-trigger"]')
      this.active = this.querySelector('tab-content.active');

      this.buttons.forEach((button) => {
        button.addEventListener('click', (e) => {
          let index = e.currentTarget.getAttribute('data-content');
          console.log(index);
          if(!index) return;

          let target = this.querySelector('tab-content[data-content="'+index+'"]');
          if(!target) return;

          this.active?.classList.remove('active');
          target.classList.add('active');
          this.active = target;

          this.buttonActive?.classList.remove('active');
          e.currentTarget.classList.add('active');
          this.buttonActive = e.currentTarget;

        });
      });
    }
  }
  if(customElements.get('horizontal-tabs') === undefined) 
    customElements.define('horizontal-tabs', HorizontalTabsComponent);
}